import { render } from "./PaymentTotal.vue?vue&type=template&id=60560757&scoped=true"
import script from "./PaymentTotal.vue?vue&type=script&lang=js"
export * from "./PaymentTotal.vue?vue&type=script&lang=js"

import "./PaymentTotal.vue?vue&type=style&index=0&id=60560757&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60560757"]])

export default __exports__